module.exports = __webpack_public_path__ + "static/media/pyro.6c374670.jpg";